import { ProcRightLogo } from "@/shared/constants/images/logo";

export interface LogoProps {
  width?: number | string;
  height?: number | string;
  style?: React.CSSProperties;
  onClick?: () => void;
}
export default function Logo({ width, height, style, onClick }: LogoProps) {
  return (
    <img
      src={ProcRightLogo}
      alt="logo"
      className="logo cursor-pointer"
      width={width}
      height={height}
      style={style}
      onClick={onClick}
    />
  );
}
